import { styled, Typography } from '@mui/material';

export const OverlinedSpanStyled = styled('span')(({ theme }) => ({
  backgroundColor: theme.palette.grey[200],
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1, 2),
}));

export const SubtextStyled = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  padding: theme.spacing(2, 0),
})) as typeof Typography;
